module.exports = __webpack_public_path__ + "static/media/2021-september-youtube.dc5f0e1f.jpg";